import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TuiButton } from '@taiga-ui/core';
import { TuiChip } from '@taiga-ui/kit';
import { SectionHeaderComponent } from '../section-header/section-header.component';

export interface BlogPost {
  title: string;
  description: string;
  date: string;
  authorName: string;
  authorDescription: string;
  authorImageUrl: string;
  link: string;
  tag: string;
}

@Component({
  selector: 'app-blog-section',
  imports: [TuiButton, TuiChip, SectionHeaderComponent],
  templateUrl: './blog-section.component.html',
  styleUrl: './blog-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogSectionComponent {
  posts = input.required<BlogPost[]>();
}
